<template>
    <div class="NotFoundComponent">
        <PagePanelWrapper>
            <!--<FiltersAndSorting />
            <ViewModes/>-->
        </PagePanelWrapper>
        <div class="NotFoundComponent__content">
            <div class="container">
            not found
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
    import PagePanelWrapper from "@/components/PagePanelWrapper";
    //import FiltersAndSorting from "@/components/FiltersAndSorting";
    //import ViewModes from "@/components/ViewModes";
    import Footer from "@/components/Footer";
    //import ObjectsPreviewList from "@/components/Object/ObjectsPreviewList";
    //import {mapState} from "vuex";

    export default {
        name: "NotFoundComponent",
        components: {
            PagePanelWrapper,
            //FiltersAndSorting,
            //ViewModes,
            Footer,
            //ObjectsPreviewList,
        }
    }
</script>